import React from 'react';
import { useController, UseControllerProps } from 'react-hook-form';
import styles from './input-number.module.scss';

interface InputNumberProps extends UseControllerProps {
  name: string,
  rules: any,
  widthLabel?: string,
  inline?: boolean
  label?: string,
  placeholder?: string,
  defaultValue?: number,
  className?: string,
  handleChange?: (str: number) => void,
  handleFocus?: () => void,
  maxlength?: number,
  disabled?: boolean,
}

const InputNumber:React.FC<InputNumberProps> = ({
  name,
  control,
  rules,
  widthLabel = null,
  inline = false,
  label = null,
  placeholder,
  defaultValue = '',
  className,
  handleChange,
  handleFocus,
  disabled,
}) => {
  const {
    field: {
      value = '',
      ref,
      onChange,
      onBlur,
    },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  function handlePressEnter(e: any) {
    if (e.key === 'Enter' && e.target) {
      e.target.blur();
    }
  }

  const inputProps: Record<number, any> = {};

  return (
    <div
      onKeyUp={(e) => handlePressEnter(e)}
      className={
      inline ? `${className ? styles[className] : ''} ${styles['container-input']} ${styles.inline}`
        : `${className ? styles[className] : ''} ${styles['container-input']}`
    }
    >
      {label && <label style={widthLabel ? { minWidth: widthLabel } : {}}>{label}</label>}
      <input
        ref={ref}
        disabled={disabled}
        value={parseFloat(value)}
        type="number"
        onBlur={onBlur}
        onFocus={() => {
          if (typeof handleFocus === 'function') handleFocus();
        }}
        onChange={(e) => {
          if (handleChange) handleChange(parseFloat(e.target.value));
          onChange(parseFloat(e.target.value));
        }}
        className={styles.input}
        placeholder={placeholder}
        {...inputProps}
      />
    </div>
  );
};

export default InputNumber;
